export const SUPPORTED_FILE_FORMATS = {
    PDF: ['.pdf', '.xfdf', '.fdf'],
    WORD: ['.doc', '.docx', '.docm', '.dot', '.dotx', '.dotm'],
    EXCEL: ['.xls', '.xlsx', '.xlsm'],
    POWERPOINT: ['.ppt', '.pptx', '.pptm', '.pot', '.pps'],
    IMAGES: ['.jpg', '.jpeg', '.png', '.jfif'],
} as const;

export const ALL_SUPPORTED_FORMATS = [
    ...SUPPORTED_FILE_FORMATS.PDF,
    ...SUPPORTED_FILE_FORMATS.WORD,
    ...SUPPORTED_FILE_FORMATS.EXCEL,
    ...SUPPORTED_FILE_FORMATS.POWERPOINT,
    ...SUPPORTED_FILE_FORMATS.IMAGES,
] as const;

export const ACCEPTED_FILES_STRING = ALL_SUPPORTED_FORMATS.join(',');
export const PDF_ONLY_STRING = SUPPORTED_FILE_FORMATS.PDF.join(',');

export const PDF_MIME_TYPE = 'application/pdf';
export const IMAGE_MIME_PREFIX = 'image/';
export const TEXT_MIME_PREFIX = 'text/';
